import React from "react";

const DropDownSelector = ({
  value,
  data,
  placeholder,
  onChange,
}) => {
  // console.log(data)
  const handleChange = (event) => {
    const { value } = event.target;
    onChange(value);
  };
  return (
    <div className={`form-group`}>
      <select value={value} className="form-control" onChange={handleChange}>
        <option value="" disabled>
          {placeholder}
        </option>

        {data.map((item, key) => (
          <option key={key} value={item.id}>
            {item.name || item.page_number}
          </option>
        ))}
      </select>
    </div>
  );
};

export default DropDownSelector;
